import { render, staticRenderFns } from "./AppAdmin.vue?vue&type=template&id=08347ebc&scoped=true&"
import script from "./AppAdmin.vue?vue&type=script&lang=js&"
export * from "./AppAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08347ebc",
  null
  
)

export default component.exports